var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconExternalLink = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0V3.02975L7.84953 2.05283L3.65897 6.16962L2.71982 5.247L6.91038 1.1302L5.76267 0H9Z",
    fill: "#008d72"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.32816 1.69321H3.71885V0.388429H0V9H8.76587V5.34661H7.4377V7.69522H1.32816V1.69321Z",
    fill: "#008d72"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconExternalLink);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon--external-link.354dd3968254ed7e36b0513b4095d001.svg";